import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApiData } from "../hooks/useApiData";
import "./AboutSection.css";
import banner80 from "../assests/banner/banner_80.jpg";
import photogallery from "../assests/img/photogallery.png";
import infrastructure from "../assests/img/infrastructure.png";
import QuickLinks from "./QuickLinks"; // adjust the path if QuickLinks.jsx lives in a different folder
import { NoticeBoard } from "./NoticeBoard"; // used for the 30% Success board

// Path to the PPT file inside the public/ppt folder
const INFRA_PPT_URL = `${process.env.PUBLIC_URL}/ppt/progress-of-lnt-2015-12-21.ppt`;

const handleOpenInfraPpt = () => {
  window.open(INFRA_PPT_URL, "_blank", "noopener,noreferrer");
};

const slugify = (str) =>
  String(str || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export function StatsBar() {
  const { data: stats, loading } = useApiData("stats");
  return (
    <div className="stats-bar">
      <div className="container">
        <div className="stats-grid">
          {loading
            ? Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="stat-item">
                  <div className="skeleton" style={{ height: 44, width: 44, borderRadius: "50%", marginBottom: 10 }} />
                  <div className="skeleton" style={{ height: 30, width: 70, marginBottom: 6 }} />
                  <div className="skeleton" style={{ height: 12, width: 90 }} />
                </div>
              ))
            : stats?.map((s, i) => (
                <div key={i} className="stat-item">
                  <div className="icond">
                    <span className="stat-icon-wrap">
                      <span className="stat-icon">{s.icon}</span>
                    </span>
                  </div>
                  <div className="textd">
                    <div className="stat-value">{s.value}</div>
                    <div className="stat-label">{s.label}</div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
}

export function AboutSection() {
  const { data, loading } = useApiData("about");
  const navigate = useNavigate();

  const eyebrow = data?.eyebrow || "About the Institution";
  const title = data?.title || "A Legacy of Excellence Since 1962";
  const detailsHtml = data?.detailsHtml || "";
  const image = data?.image || banner80;
  const badge = data?.badge || "Est. 1962";

  if (loading) {
    return (
      <section className="about-section">
        <div className="container">
          <div className="skeleton" style={{ height: 14, width: 160, marginBottom: 18 }} />
          <div className="skeleton" style={{ height: 34, width: "60%", marginBottom: 10 }} />
          <div className="skeleton" style={{ height: 34, width: "40%", marginBottom: 24 }} />

          <div className="about-flow">
            <div className="about-image-frame">
              <div className="skeleton" style={{ height: 320, borderRadius: "var(--radius-lg)" }} />
            </div>
            <div className="skeleton" style={{ height: 14, width: "100%", marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: "95%", marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: "90%", marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: "100%", marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: "85%", marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 14, width: "92%", marginBottom: 8 }} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="about-section">
      <div className="container">
        <div className="">
          <div className="leadership-section">
            <div className="about-flow">
              <div className="about-image-frame">
                <QuickLinks />
                <div className="msg_sub_sec1">
                  {/* <div
                    className="infa"
                    onClick={handleOpenInfraPpt}
                    role="button"
                    tabIndex={0}
                    style={{ cursor: "pointer" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleOpenInfraPpt();
                      }
                    }}
                  >
                    <img src={infrastructure} alt="infrastructure" /> New Infrastructure
                  </div> */}
                  {/* Hide New Infrastrucure area as not needed now */}
                  <div className="clearfix"></div>
                  <div
                    className="photogallery"
                    onClick={() => navigate("/gallery/college")}
                    role="button"
                    tabIndex={0}
                    style={{ cursor: "pointer" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate("/gallery/college"); // was "/gallery" — now matches onClick
                      }
                    }}
                  >
                    <img src={photogallery} alt="photogallery" /> Photo Gallery
                  </div>
                </div>
              </div>
              <div className="about-text">
                <p className="about-eyebrow">{eyebrow}</p>
                <h2 className=" section-title">{title}</h2>
                <div className="border0"></div>

                <div dangerouslySetInnerHTML={{ __html: detailsHtml }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function LeadershipSection() {
  const { data: leaders, loading } = useApiData("leadership");
  const list = leaders?.length ? leaders : [];

  return (
    <section className=" leadership-section">
      <div className="">
        {/* Two separate columns that both start at the top of the section:
            70% → "In Their Words" heading + leadership messages
            30% → Success Stories (full section height, its own scroll) */}
        <div className="leadership-layout">
          {/* 70% – heading + leadership messages */}
          <div className="leadership-main">
            <p className="leadership-eyebrow">In Their Words</p>
            <h2 className="section-title"> Messages From Leadership</h2>
            <div className="border1"></div>

            <div className="leadership-grid">
              {loading
                ? Array.from({ length: 2 }).map((_, i) => (
                    <div key={i} className="card leader-card custom-padding">
                      <div className="leader-header">
                        <div
                          className="skeleton"
                          style={{ width: 120, height: 120, borderRadius: "50%", flexShrink: 0 }}
                        />
                        <div style={{ flex: 1 }}>
                          <div className="skeleton" style={{ height: 12, width: "60%", marginBottom: 10 }} />
                          <div className="skeleton" style={{ height: 18, width: "80%" }} />
                        </div>
                      </div>
                      <div className="skeleton" style={{ height: 14, width: "100%", marginBottom: 8 }} />
                      <div className="skeleton" style={{ height: 14, width: "95%", marginBottom: 8 }} />
                      <div className="skeleton" style={{ height: 14, width: "70%" }} />
                    </div>
                  ))
                : list.map((l) => (
                    <div key={l.id ?? slugify(l.role)} className="card leader-card custom-padding">
                      <div className="leader-header">
                        <img
                          src={l.img}
                          alt={l.name}
                          className="leader-photo"
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              l.name
                            )}&background=00274C&color=fff&size=80`;
                          }}
                        />
                        <div>
                          <p className="leader-role">{l.role}</p>
                          <h4 className="leader-name">{l.name}</h4>
                        </div>
                        <p className="leader-message">
                          <span className="leader-quote leader-quote-open" aria-hidden="true">
                            "
                          </span>
                          {l.message}
                          <span className="leader-quote leader-quote-close" aria-hidden="true">
                            "
                          </span>
                        </p>
                      </div>

                      <Link to={`/leadership-message/${slugify(l.role)}`} className="leader-more">
                        Read full message →
                      </Link>
                    </div>
                  ))}
            </div>
          </div>

          {/* 30% – Success board.
              Uses the exact same NoticeBoard component as Notices / Tenders / MCI,
              so rows, dots, NEW badges, dates, auto-scroll and "View All" all match.
              theme="success" applies the .theme-success styles. */}
          <aside className="leadership-side">
            <NoticeBoard endpoint="success" title="Success Stories" icon="🏆" theme="success" showDetails />
          </aside>
        </div>
      </div>
    </section>
  );
}
